import { Outlet } from "react-router";
import "./App.css";
import { makeStyles, tokens } from "@fluentui/react-components";
import HeaderBar from "./HeaderBar";
import Sidebar from "./Sidebar";

const useStyles = makeStyles({
    root: {
        position: "absolute",
        top: "0",
        left: "0",
        overflow: "auto",
        height: "100vh",
        width: "100vw",
        display: "grid",
        gridTemplateRows: "50px 1fr"
    },
    content: {
        display: "flex"
    },
    sidebar: {
        display: "flex",
        flexDirection: "column",
        width: "50px",
        backgroundColor: tokens.colorNeutralBackground2
    },
    mainContent: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "2rem"
    }
});

export default function OuterTemplate() {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <HeaderBar />
            <div className={styles.content}>
                <div className={styles.sidebar}>
                    <Sidebar />
                </div>
                <div className={styles.mainContent}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}